export default "__VITE_ASSET__B13aGesK__";